import { NOTIFICATION } from '../actionTypes';

const initialState = {
  error: '',
  success: '',
};

export default (state = initialState, action) => {
  switch (action.type) {
    case NOTIFICATION.SUCCESS:
      return {
        ...state,
        error: '',
        success: action.payload,
      };
    case NOTIFICATION.ERROR:
      return {
        ...state,
        success: '',
        error: action.payload,
      };
    case NOTIFICATION.RESET:
      return {
        ...state,
        error: '',
        success: '',
      };
    default:
      return state;
  }
};
